(() => {
  const install = () => {
    if (window.__elixvpHeaderScrollCleanup) {
      window.__elixvpHeaderScrollCleanup();
      window.__elixvpHeaderScrollCleanup = null;
    }

    const header = document.querySelector('#header-group elixvp-header.is-sticky');
    if (!header) return;

    let lastY = window.scrollY;
    let ticking = false;
    const revealAfter = 120;
    const topZone = 48;

    const apply = () => {
      const y = window.scrollY;
      const delta = y - lastY;

      if (y <= topZone) {
        header.classList.remove('is-scroll-floating', 'is-scroll-hidden');
      } else if (y > revealAfter) {
        header.classList.add('is-scroll-floating');

        if (delta > 3) {
          header.classList.add('is-scroll-hidden');
        } else if (delta < -3) {
          header.classList.remove('is-scroll-hidden');
        }
      }

      lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    };

    if (lastY > revealAfter) {
      header.classList.add('is-scroll-floating', 'is-scroll-hidden');
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    window.__elixvpHeaderScrollCleanup = () => {
      window.removeEventListener('scroll', onScroll);
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }

  document.addEventListener('shopify:section:load', install);
})();

(() => {
  const portalDrawer = () => {
    customElements.whenDefined('elixvp-header').then(() => {
      requestAnimationFrame(() => {
        document.querySelectorAll('elixvp-header').forEach((header) => {
          const drawer = header.querySelector('.elixvp-header__drawer');
          if (!drawer) return;

          const logoFont = getComputedStyle(header).getPropertyValue('--eh-logo-font').trim();
          if (logoFont) drawer.style.setProperty('--eh-logo-font', logoFont);

          drawer.style.pointerEvents = 'auto';
          document.body.appendChild(drawer);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portalDrawer, { once: true });
  } else {
    portalDrawer();
  }

  document.addEventListener('shopify:section:load', portalDrawer);
})();
